// E-7-2 マイページ 写真登録
(() => {

  /**
   * 写真追加用フォームのサブミット
   */
  $(document).on('click', '#entry', () => {
    $('#member_upload_picture_form').submit();
  });


  /**
   * 写真アップロード
   */
  $(document).on('change', '#upload', () => {
    const $uploadButton = $('#upload');
    const permit_type = ['image/jpeg', 'image/png', 'image/gif'];

    // アップロードするデータが無いとき
    if ($uploadButton.val() === '') {
      return false;
    }
    const formData = new FormData();

    formData.append('member_upload_picture[file]', $uploadButton.prop("files")[0]);
    formData.append('member_upload_picture[tmp_id]', $('#member_upload_picture_tmp_id').val());
    formData.append('authenticity_token', $('[name="authenticity_token"]').val());

    $.ajax({
      url: '/upload_picture_file',
      type: 'POST',
      data: formData,
      processData: false,
      contentType: false
    }).done(data => {
      const uploadButton = document.querySelector('#upload');
      $('#image_preview img').remove();

      if ($uploadButton.prop("files")[0] && permit_type.indexOf($uploadButton.prop("files")[0].type) === -1) {
        uploadButton.value = "";
        $('#image_preview img').remove();
        // 「追加する」ボタンを非活性化
        $('#entry').addClass('btn-disabled');
      }

      if (data.result === 1) {
        $('.upload_file.error_massage').hide();
        // アップロードしたファイル情報をセット
        const $imagePreview = $('#image_preview');
        $imagePreview.append('<img class="thumbnail link" src="' + data.thumbnail.url + '" alt="アップロードした画像">');
        $imagePreview.attr('href', data.photo.url);
        $('#member_upload_picture_photo_file_name').val(data.photo.url);
        $('#member_upload_picture_photo_dir').val(data.photo.dir);
        $('#member_upload_picture_thumbnail_dir').val(data.thumbnail.dir);

        // 「追加する」ボタンを活性化
        $('#entry').removeClass('btn-disabled');
      } else {
        $('.upload_file.error_massage').html(data.error_message.join('<br>')).show();
        $('#member_upload_picture_photo_file_name').val('');
        $('#member_upload_picture_photo_dir').val('');
        // 「追加する」ボタンを非活性化
        $('#entry').addClass('btn-disabled');
      }
    }).fail(data => {
      alert('ファイルのアップロード処理にてエラーが発生しました。');
    });
  })
})();